angular.module('st')
    .controller('eventsListController', [
        '$rootScope','$scope',
        function ($rootScope,$scope) {
            var ctrl = this;

            ctrl.setOrderedMonths = function (orderedMonths) {
                $rootScope.orderedMonths = JSON.parse(orderedMonths);
            };

            ctrl.monthsAndEvents = {};
            $rootScope.monthsAndEvents = {};
            $rootScope.displayedEvents = 0;
            $rootScope.selectedMonth = 'Select Month';

            ctrl.toDisplayEvent = function (id, month, content) {
                content = content.toLowerCase();
                var searchTerm = $rootScope.eventSearchTerm.toLowerCase();

                if (content.indexOf(searchTerm) > -1 || searchTerm == '') {
                    if (ctrl.monthsAndEvents[month] == null) {
                        ctrl.monthsAndEvents[month] = [];
                    }

                    if (ctrl.monthsAndEvents[month].indexOf(id) == -1) {
                        ctrl.monthsAndEvents[month].push(id);
                        $rootScope.displayedEvents++;
                    }

                    $rootScope.monthsAndEvents = ctrl.monthsAndEvents;

                    return true;
                } else {
                    if (ctrl.monthsAndEvents[month] != null && ctrl.monthsAndEvents[month].indexOf(id) > -1) {
                        var index = ctrl.monthsAndEvents[month].indexOf(id);
                        ctrl.monthsAndEvents[month].splice(index, 1)
                        $rootScope.monthsAndEvents = ctrl.monthsAndEvents;
                        $rootScope.displayedEvents--;
                    }

                    return false;
                }
            }
        }
    ]);